import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import Classes from './Footer.module.css';
import HomeLink from '../HomeLink/HomeLink';
import { SITE } from '../../../data/siteConfig';
import { SERVICES } from '../../../data/services';
import { AREA_GROUPS } from '../../../data/serviceAreas';

const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${SITE.name} ${SITE.address.streetAddress}, ${SITE.address.addressLocality}, ${SITE.address.addressRegion} ${SITE.address.postalCode}`)}`;

const columns = [
    { title: 'Services', links: SERVICES.map((s) => ({ to: `/services/${s.slug}`, label: s.name })) },
    ...AREA_GROUPS.map((g) => ({
        title: g.county,
        links: g.areas.map((a) => ({ to: `/service-areas/${a.slug}`, label: a.city })),
    })),
    {
        title: 'Company',
        links: [
            { to: '/#why-us', label: 'Why Choose Us' },
            { to: '/#reviews', label: 'Reviews' },
            { to: '/#faq', label: 'FAQ' },
            { to: '/contact-us', label: 'Contact Us' },
        ],
    },
];

export default function Footer() {
    return (
        <footer className={Classes.footer}>
            <div className={`container ${Classes.top}`}>
                <div className={Classes.brand}>
                    <HomeLink aria-label={`${SITE.name} home`}>
                        <img src="/assets/images/Group.svg" alt={`${SITE.name} logo`} width="90" height="44" loading="lazy" className={Classes.logo} />
                    </HomeLink>
                    <p className={Classes.about}>
                        Licensed general contractor and remodeler serving Boca Raton and {SITE.region} for over 20 years.
                    </p>
                    <address className={Classes.nap}>
                        <a href={mapsUrl} target="_blank" rel="noopener noreferrer">
                            <FaMapMarkerAlt />
                            <span>{SITE.address.streetAddress}, {SITE.address.addressLocality}, {SITE.address.addressRegion} {SITE.address.postalCode}</span>
                        </a>
                        <a href={`tel:${SITE.phoneE164}`}><FaPhoneAlt /><span>{SITE.phone}</span></a>
                        <span><FaClock /><span>{SITE.hours}</span></span>
                    </address>
                    <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className={Classes.bookLink}>
                        Book an appointment online →
                    </a>
                </div>

                <nav className={Classes.columns} aria-label="Footer">
                    {columns.map((col) => (
                        <div key={col.title}>
                            <h3>{col.title}</h3>
                            <ul>
                                {col.links.map((l) => (
                                    <li key={l.to}><Link to={l.to}>{l.label}</Link></li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </nav>
            </div>

            <div className={`container ${Classes.bottom}`}>
                <span>© {new Date().getFullYear()} {SITE.legalName}. All rights reserved.</span>
                <span className={Classes.license}>Licensed &amp; Insured · FL License #{SITE.license}</span>
                <span className={Classes.legal}>
                    <Link to="/terms-of-service">Terms of Service</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </span>
            </div>
        </footer>
    );
}
